<template>
     <div>
         <div class="panel panel-default">
           <div class="panel-heading">
               <div style="display: flex; justify-content: space-between; align-items: center;">
                   <span>
                       Campaigns
                   </span>
               </div>
           </div>
           <div class="panel-body">
                <div style="overflow-x: auto">
                    <table class="table campaigns">
                       <thead>
                           <tr>
                               <th>Vendor</th>
                               <th>Name</th>
                               <th>Remove</th>
                           </tr>
                       </thead>
                       <tbody>
                           <tr v-for="(campaign, idx) in campaigns" :key="campaign.campaign_id">
                               <td>
                                   {{ getVendorForCampaign(campaign) }}
                               </td>
                               <td>
                                   {{ campaign.name }}
                               </td>
                               <td data-label="Remove">
                                   <button class="btn btn-danger-outline btn-sm" @click="remove(campaign)"><span class="fa fa-times"></span></button>
                                </td>
                           </tr>
                       </tbody>
                    </table>
                </div>
               </div>
           </div>
         </div>
     </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
        }
    },

    computed: {
        ...mapGetters('client',{
            'budget': 'activeBudgetGroup',
            'isAdmin': 'isAdmin',
            'client': 'activeClient',
        }),

        campaigns() {
            return this.budget.campaigns.sort((a, b) => {
                if(a.vendor < b.vendor) return -1;
                if(a.vendor > b.vendor) return 1;
                return 0;
            });
        }
    },

    methods: {
        remove(campaign) {
            this.$store.dispatch('client/removeCampaignFromBudgetGroup', {
                campaign: campaign
            });
        },

        getVendorForCampaign(campaign) {
            return this.client.ad_accounts.find(account => account.account_id === campaign.account_id).vendor;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/BudgetGroupCampaignList.vue